export default {
    state: {
        generalPractitioner: null,
    },

    getters: {
        generalPractitioner: (state) => {
            return state.generalPractitioner;
        },
    },

    mutations: {
        setGeneralPractitioner(state, generalPractitioner) {
            state.generalPractitioner = generalPractitioner;
        }
    },
}
